// Цвет поисковой подсветки (query_highlights) — тёплый оранжевый.
// Задан отдельно, чтобы визуально не совпадать с цветами рубрик.
export const QUERY_COLOR = "#E8590C";

// Диапазон hue для рубрик — от 40° (тёплый жёлто-оранжевый) до 320° (пурпур).
// Красная зона (~320..360 и 0..40) исключена: красным подсвечиваются ошибки,
// плюс он визуально конкурирует с оранжевой поисковой подсветкой.
const HUE_START = 40;
const HUE_RANGE = 280;

// Цвет для рубрики по её позиции в списке рубрик новости.
// Цвет привязан к индексу, а не к id: рубрика на первой позиции всегда
// первого цвета, на второй — второго и т.д. Hue раскидываем по золотому
// сечению внутри разрешённого диапазона — соседние индексы получают
// заметно разные, но приглушённые оттенки.
export function rubricColor(index) {
    if (typeof index !== "number" || index < 0) {
        return "hsl(0, 0%, 60%)";
    }
    // 137 ~ 360 * (1 - 1/φ) — равномерно раскидывает hue при инкременте на 1.
    const hue = HUE_START + ((index * 137) % HUE_RANGE);
    return `hsl(${hue}, 45%, 50%)`;
}
